import React, { useEffect, useState } from "react";
import HealthSubpageLayout from "../../../components/HealthSubpageLayout";
import EpsSubpageHeader from "../../../components/Monitoring/EpsSubpageHeader/EpsSubpageHeader";
import EpsColumnFilters from "../../../components/Monitoring/EpsColumnFilters/EpsColumnFilters";
import { getEmptyEpsFilters, MC_EPS_FILTERS } from "../../../components/Monitoring/epsFilters";
import useDebounce from "../../../../../hooks/use-debounce";
import Images from "../../../../../Images";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MastercardEstimatedProgramStatusTable from "./Table/MastercardEstimatedProgramStatusTable";
import { monitoringInit } from "../../../redux/health.thunks";
import { useBusinessAccountId } from "../../../VAMP/hooks/useBusinessAccountId";

const MastercardEstimatedProgramStatusPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { monitoringInitialized } = useSelector((state) => state.health);

  const business_account_id = useBusinessAccountId();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 400);
  const [columnFilters, setColumnFilters] = useState(() => getEmptyEpsFilters(MC_EPS_FILTERS));

  useEffect(() => {
    if (!monitoringInitialized) {
      dispatch(monitoringInit({ business_account: business_account_id }));
    }
  }, []);

  return (
    <HealthSubpageLayout backText={t("Back to Health")}>
      <EpsSubpageHeader
        brandLabel="Mastercard"
        brandImage={Images.mastercard_3d}
        search={search}
        onSearch={setSearch}
      />
      <EpsColumnFilters
        filtersMap={MC_EPS_FILTERS}
        filters={columnFilters}
        onChange={setColumnFilters}
      />
      <MastercardEstimatedProgramStatusTable
        business_account_id={business_account_id}
        variant="page"
        withPagination
        pageSize={50}
        search={debouncedSearch}
        columnFilters={columnFilters}
      />
    </HealthSubpageLayout>
  );
};

export default MastercardEstimatedProgramStatusPage;
